export function addAuthNetScript (src) {
  const script = document.createElement('script')
  script.src = src
  document.head.appendChild(script)
}

export function removeAuthNetScript (src) {
  const head = document.head
  const scripts = head.getElementsByTagName('script')

  Array.from(scripts)
    .filter(script => script.src === src)
    .forEach(injectedScript => head.removeChild(injectedScript))
}
